import React from 'react';
import { useTranslation } from 'react-i18next';
import { ps } from '@petscreening/embedded-flow-sdk';

import { Row, Title, PageContainer, PageWrapper, Description } from '../common-styles';
import Button from 'components/button';
import Checkbox from 'components/checkbox';

// eslint-disable-next-line no-undef
const PET_SCREENING_ENVIRONMENT = `${process.env.REACT_APP_PET_SCREENING_EMBED_URL}`;

const PetScreeningEmbed = ({ application, location, saveApplicationPart, onNext, onBack }) => {
  const { t } = useTranslation();
  const handleNext = (petScreeningData) => {
    saveApplicationPart({ petScreeningEmbed: true, petScreeningData }, false).then(() => {
      onNext();
    });
  };

  React.useEffect(() => {
    const spId = location?.companyInfo?.petScreeningDetails?.serviceProviderId;
    ps.initEmbeddedFlow('#pet-screening-launcher', {
      overrideUrl: PET_SCREENING_ENVIRONMENT,
      queryParams: { serviceProviderId: spId },
      callbacks: {
        close: (...props) => {
          console.log('Close Event received:', props);
          document.body.style.overflowY = 'auto';
        },
        onEvent: (...props) => {
          console.log('Event received:', props);
        },
        petProfilesCompleted: (props) => {
          console.log('PetProfilesCompleted:', props);
          handleNext(props.data);
        }
      }
    });
  }, []);

  return (
    <PageWrapper>
      <PageContainer>
        <Row className="center text-center">
          <Title>{t('petsMembers.title')}</Title>
        </Row>
        {location?.applicationConfig?.petBlurb && (
          <Row>
            <Description
              dangerouslySetInnerHTML={{
                __html: location.applicationConfig.petBlurb
              }}
            />
          </Row>
        )}
        <Row className="center flex gap-10">
          <Button radius="25px" variant="secondary" width={90} onClick={onBack}>
            {t('buttonsActions.cancel')}
          </Button>
          <Button id="pet-screening-launcher" radius="25px" variant="primary">
            Continue to PetScreening.com
          </Button>
        </Row>
      </PageContainer>
    </PageWrapper>
  );
};

const PetScreening = ({ application, location, saveApplicationPart, onNext, onBack }) => {
  const { t } = useTranslation();
  const [acked, setAcked] = React.useState(!!application.consent?.petScreening);
  const [loading, setLoading] = React.useState(false);

  const handleNext = () => {
    if (!acked || loading) return;
    setLoading(true);
    saveApplicationPart({ consentPetScreening: acked }, false)
      .then(() => {
        onNext();
      })
      .catch(() => setLoading(false));
  };

  return (
    <PageWrapper>
      <PageContainer>
        <Row className="center text-center">
          <Title>{t('petsMembers.title')}</Title>
        </Row>
        {location?.applicationConfig?.petBlurb && (
          <Row>
            <Description
              dangerouslySetInnerHTML={{
                __html: location.applicationConfig.petBlurb
              }}
            />
          </Row>
        )}
        <Row>
          <Checkbox
            checked={acked}
            onChange={() => setAcked(!acked)}
            label={t('petsMembers.petScreeningCheck')}
          />
        </Row>
        <Row className="center flex gap-10">
          <Button radius="25px" variant="secondary" width={90} onClick={onBack}>
            {t('buttonsActions.cancel')}
          </Button>
          <Button
            radius="25px"
            variant="primary"
            onClick={handleNext}
            width={90}
            loading={loading}
            disabled={!acked || loading}>
            {t('buttonsActions.next')}
          </Button>
        </Row>
      </PageContainer>
    </PageWrapper>
  );
};

const vendorComponents = {
  petScreeningEmbed: PetScreeningEmbed,
  petScreening: PetScreening
};

export default ({ petScreeningVendor, ...params }) => {
  let Component = vendorComponents[petScreeningVendor] || vendorComponents.petScreening;

  return <Component {...params} />;
};
